import { graphql, useStaticQuery } from 'gatsby';

// static query for navlist of city works series - no images needed
const useCityWorks = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        filter: { frontmatter: { series: { eq: "City Works" } } }
        sort: { fields: [frontmatter___name], order: ASC }
      ) {
        nodes {
          frontmatter {
            name
            slug
            title
            series
            media
            size
            year
            city
            state
            country
          }
        }
      }
    }
  `);

  return data.allMdx.nodes;
};

export default useCityWorks;
